module.exports = __webpack_public_path__ + "img/flat-eprice-button-hyundai.3bf2efd6.png";